import { Component, ChangeDetectionStrategy } from '@angular/core';

import { SnTagRecord } from '@lib/api/entities';
import { SnListBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-tag-record-list',
  templateUrl: './tag-record-list.component.html',
  styleUrls: ['./tag-record-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagRecordListComponent extends SnListBaseComponent<SnTagRecord> {
  constructor() {
    super();
  }

  public trackBy(index: number, item: SnTagRecord): any {
    return item.id;
  }
}
